import React, {ComponentType, Suspense, lazy, useMemo} from 'react';

import {SmallLoader} from '@kit';

import {useUser} from '../use-user';
import {cls} from '../utils';

import css from './edit-hoc.module.css';

type Props<P> = {
	children: React.ReactNode;
	/** загрузчик кнопки правки; вызывается только у администратора */
	load: () => Promise<ComponentType<P>>;
	/** пропсы кнопки правки */
	editProps: P;
	/** что навесить на обёртку: так блок становится местом, куда можно бросить перетаскиваемый */
	wrapper?: React.HTMLAttributes<HTMLDivElement>;
	/** обёртка по размеру содержимого: кнопки встают на сам элемент, а не на всю ширину блока */
	inline?: boolean;
};

export function EditHoc<P extends object>({load, editProps, children, wrapper, inline}: Props<P>) {
	const {isAdmin} = useUser();

	const Edit = useMemo(() => (isAdmin ? lazy(() => load().then((module) => ({default: module}))) : null), [isAdmin]);

	if (!Edit) return <>{children}</>;

	return (
		<div {...wrapper} className={cls(css.wrapper, inline && css.inline, wrapper?.className)}>
			<div className={css.edit}>
				<Suspense fallback={<SmallLoader />}>
					<Edit {...editProps} />
				</Suspense>
			</div>
			{children}
		</div>
	);
}
